import { C, F } from "./theme/tokens";
import { apriPreferenzeCookie, leggiConsenso } from "./consenso/consenso";

/**
 * Cookie policy: l'elenco di quello che il sito puo' scrivere nel browser,
 * diviso per categoria, con durata e scopo. I cookie di statistiche e
 * marketing esistono solo dopo il consenso dato nel banner.
 */

const TECNICI = [
  ["obscura_sessione", "cookie", "30 giorni dall'ultimo uso", "Tiene aperto l'accesso all'account. Solo per chi ha un account."],
  ["obscura_lavoro_corrente", "memoria locale", "circa 1 ora", "Ricorda gli identificativi e i nomi dei file dell'anonimizzazione in corso, per non perderla se la pagina si ricarica. Nessun documento."],
  ["obscura_lavori_recenti", "memoria locale", "circa 1 ora", "L'elenco delle ultime anonimizzazioni fatte da questo browser (identificativi e nomi dei file), per riaprirle finché i documenti esistono."],
  ["obscura_piano_scelto", "memoria locale", "7 giorni", "Ricorda il piano scelto dalla pagina prezzi durante la registrazione."],
  ["obscura_consenso", "memoria locale", "6 mesi", "Ricorda la scelta fatta nel banner e il codice casuale con cui è registrata sui nostri sistemi."],
  ["obscura_checkout_importo, obscura_tracciato_*", "memoria della scheda", "fino alla chiusura della scheda", "Pagine e importo del pagamento in corso, e i pagamenti già misurati: servono a contare le conversioni una volta sola. Nessun dato personale."],
];

const STATISTICHE = [
  ["_ga, _ga_*", "Google Analytics", "fino a 2 anni", "Distingue i visitatori e le sessioni per contare visite e uso del sito, in forma aggregata."],
];

const MARKETING = [
  ["_gcl_au, _gcl_aw", "Google Ads", "3 mesi", "Misura se una visita arriva da una campagna e se porta a un'azione."],
  ["IDE, test_cookie", "Google Ads (doubleclick.net)", "fino a 13 mesi", "Annunci pertinenti e misurazione delle conversioni."],
  ["_fbp, fr", "Meta (Facebook, Instagram)", "3 mesi", "Misura le campagne Meta e mostra annunci pertinenti."],
];

function Tabella({ righe }) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, lineHeight: 1.5 }}>
        <thead>
          <tr>
            {["Nome", "Chi lo imposta / tipo", "Durata", "A cosa serve"].map((h) => (
              <th key={h} style={{ textAlign: "left", padding: "8px 10px", borderBottom: `2px solid ${C.border}`, color: C.textTitle, fontWeight: 700, whiteSpace: "nowrap" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {righe.map((r) => (
            <tr key={r[0]}>
              {r.map((cella, i) => (
                <td key={i} style={{ padding: "8px 10px", borderBottom: `1px solid ${C.border}`, color: C.textBody, verticalAlign: "top", fontFamily: i === 0 ? "ui-monospace, Menlo, monospace" : F.b, fontSize: i === 0 ? 12 : 13 }}>{cella}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function CookiePolicyPage({ onBack }) {
  const h2 = { fontFamily: F.h, fontSize: 20, color: C.textTitle, margin: "28px 0 10px" };
  const p = { fontSize: 14, color: C.textBody, lineHeight: 1.65, margin: "0 0 12px" };
  const scelta = leggiConsenso();
  return (
    <div style={{ minHeight: "100vh", background: C.smartBlue10, fontFamily: F.b }}>
      <div style={{ background: C.white, borderBottom: `1px solid ${C.border}`, padding: "0 16px", minHeight: 64, display: "flex", alignItems: "center", gap: 12, position: "sticky", top: 0, zIndex: 50 }}>
        <button type="button" onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", color: C.smartBlue, fontSize: 14, fontWeight: 500, fontFamily: F.b, padding: 0 }}>&lsaquo; Torna al sito</button>
        <span style={{ color: C.border }}>|</span>
        <h1 style={{ fontSize: 17, fontWeight: 500, fontFamily: F.h, color: C.textTitle, margin: 0 }}>Cookie policy</h1>
      </div>
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "32px 16px 64px" }}>
        <section style={{ background: C.white, borderRadius: C.radiusSection, border: `1px solid ${C.border}`, padding: 24 }}>
          <p style={p}>
            Questa pagina elenca i cookie e gli altri dati che il sito OBSCURA (obscura.gridplus.it), gestito da GRID+ S.r.l., pu&ograve; salvare nel tuo browser, perch&eacute; e per quanto tempo. I cookie tecnici servono al funzionamento del sito e non richiedono consenso. Quelli statistici e di marketing vengono impostati solo se li accetti nel banner, e puoi cambiare scelta in qualunque momento.
          </p>
          <p style={p}>
            Ogni scelta viene registrata anche sui nostri sistemi con un codice casuale, la data e le categorie accettate: &egrave; la prova del consenso che la legge ci chiede di conservare. Nel registro non ci sono indirizzi IP n&eacute; dati che ti identificano.
          </p>
          {scelta?.id && (
            <p style={p}>
              Il tuo codice di consenso &egrave; <code style={{ fontFamily: "ui-monospace, Menlo, monospace", fontSize: 13, background: C.smartBlue10, padding: "2px 6px", borderRadius: 6 }}>{scelta.id}</code>: indicalo se ci scrivi per una richiesta sui cookie.
            </p>
          )}
          <p style={{ ...p, margin: 0 }}>
            <button type="button" onClick={() => apriPreferenzeCookie()} style={{ background: C.smartBlue20, border: `1px solid ${C.smartBlue30}`, borderRadius: 8, padding: "8px 14px", color: C.smartBlue, fontWeight: 600, cursor: "pointer", fontFamily: F.b, fontSize: 13 }}>Cambia le preferenze cookie</button>
          </p>

          <h2 style={h2}>Cookie tecnici (sempre attivi)</h2>
          <Tabella righe={TECNICI} />

          <h2 style={h2}>Statistiche (con il tuo consenso)</h2>
          <p style={p}>Google Analytics 4, tramite Google Tag Manager. I dati sono aggregati e gli indirizzi IP non vengono conservati.</p>
          <Tabella righe={STATISTICHE} />

          <h2 style={h2}>Marketing (con il tuo consenso)</h2>
          <p style={p}>Google Ads e Meta, tramite Google Tag Manager, per misurare le campagne e mostrare annunci pertinenti. Senza consenso questi strumenti non ricevono dati riconducibili a te.</p>
          <Tabella righe={MARKETING} />

          <h2 style={h2}>Cosa non finisce mai nel browser n&eacute; nei sistemi di terzi</h2>
          <p style={p}>
            I documenti che carichi, il loro contenuto e i loro nomi: restano tra il tuo browser e i nostri sistemi, dove vengono eliminati entro circa un&apos;ora dall&apos;elaborazione. Gli strumenti di statistica e marketing ricevono solo conteggi e importi, mai dati personali.
          </p>

          <h2 style={h2}>Per saperne di pi&ugrave;</h2>
          <p style={{ ...p, margin: 0 }}>
            Come Google e Meta trattano i dati &egrave; descritto nelle loro informative: policies.google.com/technologies/cookies e facebook.com/privacy/policies/cookies. Per tutto il resto vale l&apos;informativa privacy di OBSCURA. Ultimo aggiornamento: settembre 2026.
          </p>
        </section>
      </div>
    </div>
  );
}
